import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=e7067076&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7067076')) {
      api.createRecord('e7067076', component.options)
    } else {
      api.reload('e7067076', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=e7067076&", function () {
      api.rerender('e7067076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotScore/goods.vue"
export default component.exports